import React, { Component } from "react";
import Base from "../../components/Base";
import { FaExchangeAlt } from "react-icons/fa";

import "./styles.css";
import {
  notification,
  Spin,
  Pagination,
  Button,
  Modal,
  Alert,
  Checkbox,
  Icon
} from "antd";
import api from "../../services/api";

import ParcelaRow from "./ParcelaRow";
import Filter from "../../components/Filter";
import * as Permissions from "../../services/permissions";

export default class Parcelas extends Component {
  state = {
    loading: true,
    actionLoading: false,
    allSelected: false,
    parcelaSelectStatus: {},
    currentPage: 1,
    totalItems: 0,
    filterModalDisplay: false,
    filterRequestParams: {},
    responseData: [],
    filterOptions: [
      {
        key: "data_vencimento",
        text: "Data vencimento",
        type: "date",
        option_type: ["gte", "lte", "exact"]
      },
      {
        key: "data_pagamento",
        text: "Data pagamento",
        type: "date",
        option_type: ["gte", "lte", "exact"]
      },
      {
        key: "notafiscal__numero_nf",
        text: "Nº nota fiscal",
        type: "text",
        option_type: ["exact"]
      },
      {
        key: "notafiscal__status",
        text: "Status nota fiscal",
        type: "option",
        option_type: ["exact"],
        options: [
          {
            id: "1",
            text: "Conciliado"
          },
          {
            id: "2",
            text: "Não conciliado"
          }
        ]
      },
      {
        key: "status_parcela",
        text: "Status parcela",
        type: "option",
        option_type: ["iexact"],
        options: [
          {
            id: "0",
            text: "Não paga"
          },
          {
            id: "1",
            text: "Paga"
          },
          {
            id: "2",
            text: "Cancelada"
          }
        ]
      },
      {
        key: "acordo__pasta__pasta",
        text: "Pasta",
        type: "text",
        option_type: ["iexact"]
      },
      {
        key: "acordo__pasta__carteira",
        text: "Carteira",
        type: "text",
        option_type: ["iexact"]
      },
      {
        key: "acordo__pasta__num_sinistro",
        text: "Número de sinistro",
        type: "text",
        option_type: ["iexact"]
      },
      {
        key: "acordo__status_acordo",
        text: "Status acordo",
        type: "option",
        option_type: ["exact"],
        options: [
          {
            id: "Ativo",
            text: "Ativo"
          },
          {
            id: "Quebrado - Erro HDI",
            text: "Quebrado - Erro HDI"
          },
          {
            id: "Quebrado - Não pagamento",
            text: "Quebrado - Não pagamento"
          },
          {
            id: "Reacordo",
            text: "Reacordo"
          },
          {
            id: "Quitado",
            text: "Quitado"
          },
          {
            id: "Quebrado",
            text: "Quebrado"
          }
        ]
      }
    ]
  };

  componentDidMount() {
    this.loadData();
  }

  handlePageChange = page => {
    this.setState(
      {
        currentPage: page
      },
      this.loadData
    );
  };

  handleFilterParamUpdate = params => {
    this.setState({
      filterRequestParams: params != null ? params : {},
      currentPage: 1
    });
  };

  handleAllSelect = () => {
    this.setState({
      allSelected: !this.state.allSelected,
      parcelaSelectStatus: {}
    });
  };

  /**
   * Marca uma parcela como selecionada ou não
   * @param {Boolean} value - true or false
   * @param {Number} id - Id da parcela
   */
  handleParcelaSelect = (value, id) => {
    const obj = this.state.parcelaSelectStatus;

    obj[`${id}-id`] = value;

    this.setState({
      parcelaSelectStatus: obj
    });
  };

  /**
   * Altera o status das notas selecionadas na tabela
   * @param {String} status - Status da nota
   */
  handleStatusConciliarAll = async status => {
    const allSelected = this.state.allSelected;
    let list = [];

    if (allSelected === true) {
      list = Object.keys(this.state.parcelaSelectStatus).filter(
        selected => this.state.parcelaSelectStatus[selected] === false
      );
    } else {
      list = Object.keys(this.state.parcelaSelectStatus).filter(
        selected => this.state.parcelaSelectStatus[selected] === true
      );
    }

    /** Transform values to int -> 9999-id -> 9999 */
    list = list.map(id => parseInt(id.split("-")[0]));

    this.setState({
      actionLoading: true
    });

    await api
      .put("/parcela/", {
        all_selected: allSelected,
        values: list,
        notafiscal_status: status
      })
      .then(response => {
        notification.success({
          message:
            status == "2"
              ? "Notas fiscais desconciliadas com sucesso."
              : "Notas fiscais conciliadas com sucesso!"
        });
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          notification.error({
            message: err.response.data.message
          });
        }
      });

    this.setState({
      actionLoading: false
    });

    // Recarrega as parcelas
    this.loadData();
  };

  /**
   * Mostra uma tela de confirmação para o
   * usuário conciliar as notas fiscais em massa.
   */
  handleAskConciliar = () => {
    const modal = Modal.confirm();

    modal.update({
      title: "Confirmar conciliação",
      okText: "Confirmar",
      cancelText: "Cancelar",
      content: (
        <div>
          Você deseja conciliar <b>{this.getSelectedCount()}</b> notas fiscais?
        </div>
      ),
      okCancel: modal.destroy,
      onOk: () => this.handleStatusConciliarAll("1")
    });
  };

  /**
   * Mostra uma tela de confirmação para o
   * usuário desconciliar as notas fiscais em massa.
   */
  handleAskDesconciliar = () => {
    const modal = Modal.confirm();

    modal.update({
      title: "Confirmar desconciliação",
      okText: "Confirmar",
      cancelText: "Cancelar",
      content: (
        <div>
          Você deseja desconciliar <b>{this.getSelectedCount()}</b> notas
          fiscais?
        </div>
      ),
      okCancel: modal.destroy,
      onOk: () => this.handleStatusConciliarAll("2")
    });
  };

  /**
   * Retorna o número total de linhas selecionadas
   */
  getSelectedCount = () => {
    const allSelected = this.state.allSelected;
    const total = this.state.totalItems;

    if (allSelected === true) {
      const notSelected = Object.keys(this.state.parcelaSelectStatus).filter(
        selected => this.state.parcelaSelectStatus[selected] === false
      ).length;

      return total - notSelected;
    } else {
      const selected = Object.keys(this.state.parcelaSelectStatus).filter(
        selected => this.state.parcelaSelectStatus[selected] === true
      ).length;

      return selected;
    }
  };

  loadDataExport = async () => {
    // Carrega as parcelas
    console.log("aqui");
    this.setState({
      loading: true
    });

    await api
      .get("/parcela/", {
        params: {
          page: this.state.currentPage,
          ...this.state.filterRequestParams,
          download: true
        }
      })
      .then(response => {
        console.log(response);
        let link = response.data.link;
        link = link.replace(
          "http://api.hub.debt.com",
          "http://api.debt.com.br/"
        );
        window.open(link);
      })
      .catch(err => {
        console.log(err);
        notification.error({
          message: "Falha ao carregar as informações."
        });
      });

    this.setState({
      loading: false,
      filterModalDisplay: false,
      allSelected: false,
      parcelaSelectStatus: {}
    });
  };

  loadData = async () => {
    // Carrega as parcelas
    this.setState({
      loading: true
    });

    await api
      .get("/parcela/", {
        params: {
          page: this.state.currentPage,
          ...this.state.filterRequestParams
        }
      })
      .then(response => {
        this.setState({
          responseData: response.data.results,
          totalItems: response.data.count
        });
      })
      .catch(() => {
        notification.error({
          message: "Falha ao carregar as informações."
        });
      });

    this.setState({
      loading: false,
      filterModalDisplay: false,
      allSelected: false,
      parcelaSelectStatus: {}
    });
  };

  render() {
    const selectedCount = this.getSelectedCount();

    if (!Permissions.has("acordo.parcela_listar")) {
      return (
        <Base title="Parcelas" subTitle="Listagem de parcelas">
          <div>
            <Alert type="error" message="Sem permissão." />
          </div>
        </Base>
      );
    }

    return (
      <Base title="Parcelas" subTitle="Listagem de parcelas">
        <div className="parcelas-container">
          {this.state.loading ? (
            <div style={{ textAlign: "center" }}>
              <Spin />
            </div>
          ) : (
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ width: "12%" }}>
                  <div>
                    Total: <b>{this.state.totalItems}</b>
                  </div>
                  <div>
                    Selecionado: <b>{selectedCount}</b>
                  </div>
                </div>
                <div className="parcelas-btns" style={{ width: "88%" }}>
                  {this.state.actionLoading ? (
                    <div style={{ textAlign: "center" }}>
                      <Spin />
                    </div>
                  ) : (
                    <React.Fragment>
                      <Button
                        type="primary"
                        disabled={selectedCount === 0}
                        onClick={this.handleAskConciliar}
                      >
                        <Icon component={FaExchangeAlt} />
                        Conciliar selecionados
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        type="danger"
                        disabled={selectedCount === 0}
                        onClick={this.handleAskDesconciliar}
                      >
                        <Icon component={FaExchangeAlt} />
                        Desconciliar selecionados
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        type="primary"
                        icon="filter"
                        onClick={() =>
                          this.setState({ filterModalDisplay: true })
                        }
                      >
                        Filtrar
                      </Button>
                      &nbsp;&nbsp;
                      <Button
                        type="primary"
                        icon="export"
                        onClick={() => this.loadDataExport()}
                      >
                        Exportar
                      </Button>
                      {/* &nbsp;&nbsp;
                      <Button type="primary" icon="file-excel">
                        Exportar dados
                      </Button> */}
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div
                style={{
                  overflowX: "scroll"
                }}
              >
                <table className="acordoview__table parcelas__table">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>
                        <Checkbox
                          onChange={this.handleAllSelect}
                          checked={this.state.allSelected}
                        />
                      </th>
                      <th>PASTA</th>
                      <th>NF</th>
                      <th>DT CONCILIAÇÃO</th>
                      <th>VALOR PARC.</th>
                      <th>VALOR PAGO</th>
                      <th>DATA PGTO.</th>
                      <th>DATA VCTO.</th>
                      <th>CARTEIRA</th>
                      <th>% HONOR.</th>
                      <th>STATUS</th>
                      <th>AÇÕES</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.responseData.map(parcela => (
                      <ParcelaRow
                        parcelaData={parcela}
                        key={parcela.id}
                        allSelected={this.state.allSelected}
                        parcelaStatus={this.state.parcelaSelectStatus}
                        handleParcelaSelect={this.handleParcelaSelect}
                      />
                    ))}
                  </tbody>
                </table>
              </div>

              {this.state.responseData.length == 0 ? (
                <div style={{ textAlign: "center", padding: "10px" }}>
                  <Alert type="info" message="Sem resultados" />
                </div>
              ) : null}

              <div style={{ textAlign: "center", margin: "20px" }}>
                <Pagination
                  defaultCurrent={this.state.currentPage}
                  defaultPageSize={20}
                  total={this.state.totalItems}
                  onChange={this.handlePageChange}
                />
              </div>
            </div>
          )}
        </div>

        {/** Modal do filtro */}
        <Modal
          visible={this.state.filterModalDisplay}
          title="Filtrar"
          loading={this.state.loading}
          onOk={this.loadData}
          onCancel={() => this.setState({ filterModalDisplay: false })}
          okText="Filtrar"
          cancelText="Cancelar"
          width={800}
        >
          <Filter
            data={this.state.filterOptions}
            paramSetter={this.handleFilterParamUpdate}
          />
        </Modal>
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Parcelas/index.js